<template>
	<div v-if="!hasReview" class="alert alert-primary mt-4">You do not currently have a review for this artwork.</div>
	<div v-if="editingReview" class="artwork-review-form mt-4">
		<textarea v-model="comment" class="form-control" name="" id="" cols="30" rows="10"></textarea>

		<div class="d-flex w-100">
			<div class="form-check mt-2">
				<label for="artwork-shortlist" class="form-check-label">
					Short list
				</label>
				<input v-model="shortlist" type="checkbox" id="artwork-shortlist" class="form-check-input">
			</div>
			<div class="form-check mt-2 ms-auto">
				<label for="artwork-nominated" class="form-check-label">
					Nominate as finalist
				</label>
				<input v-model="finalist" type="checkbox" id="artwork-nominated" class="form-check-input">
			</div>
		</div>

		<div class="btn-group mt-2" role="group" aria-label="Review Controls">
			<button @click="saveReview" class="btn btn-success" :disabled="isLoading">
				<loading-spinner message="Saving..." v-if="isLoading"></loading-spinner>
				<span v-else>Save</span>
			</button>
			<button @click="resetData" class="btn btn-danger" v-if="!isLoading">Cancel</button>


			<div v-if="isError" class="error">
				<div class="col-12">
					<p class="text-center">
						<i class="fas fa-exclamation-triangle text-danger"></i>
						An error occurred or your security token has expired.<br>
						Please <a :href="loginPage">return to the login page</a>.
					</p>
				</div>
			</div>
		</div>

	</div>
	<a v-else class="btn btn-primary mt-4" @click="editingReview = true">{{ reviewButton }}</a>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';

export default {
	emits: ['saved'],

	components: {
		LoadingSpinner
	},

	props: {
		artwork: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			comment: '',
			shortlist: 'No',
			finalist: 'No',
			editingReview: false,
			isLoading: false,
			isError: false,
		}
	},

	methods: {
		resetData() {
			if (this.review) {
				this.comment = this.review.comment;
				this.shortlist = this.review.shortlist == 'Yes';
				this.finalist = this.review.finalist == 'Yes';
				this.artwork_id = this.artwork.id;
			}
			this.editingReview = false;
		},
		saveReview() {
			if (this.isLoading) return;

			this.isLoading = true;
			this.$store.dispatch('updateReview', {
				artwork_id: this.artwork.id,
				reviewed: true,
				shortlist: this.shortlist,
				finalist: this.finalist,
				comment: this.comment
			})
				.then((response) => {

				})
				.catch(error => {
					console.error(error);
					this.isError = true;
				})
				.finally(() => {
					this.isLoading = false;

					this.$emit('saved');
					this.resetData();
				});
		},
	},

	mounted() {
		this.resetData();
	},

	computed: {
		review() {
			return this.$store.getters.getMyReview(this.artwork);
		},
		myShortlist() {
			return this.review && this.review.shortlist == 'Yes';
		},
		myNomination() {
			return this.review && this.review.finalist == 'Yes';
		},
		myComment() {
			return this.review ? this.review.comment : '';
		},
		reviewButton() {
			return this.hasReview ? 'Update Review' : 'Create Review';
		},
		hasReview() {
			return this.artwork.reviews.find(o => o.author === this.$store.getters.getUserId) != null;
		}
	}
}
</script>